import { use, useEffect, useState } from "react";
import { getService } from "../GenericServices/genericService";

const CategoryFilter = ({ selectedCategory, onCategoryChange }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getCategoriesAPI();
  }, []);

  const getCategoriesAPI = () => {
    const url = "myNewAPI/get_category.php";
    getService(url, {}, getCategoriesData);
  };

  const getCategoriesData = (data) => {
    console.log("Categories Data:", data);
    if (data && data.category) {
      const catData = [
        { id: 0, cat_name: "All", cat_title: "All" },
        ...data.category,
      ];
      setCategories(catData);
    }
  };

  console.log("Categores:", categories);

  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold mb-4">Categories</h3>
      <div className="flex flex-wrap gap-2">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category)}
            className={`px-4 py-2 rounded-md transition duration-200 ${
              selectedCategory.id === category.id
                ? "bg-red-600 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            {category.cat_title}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;
